/**
 * @typedef HeadersTable
 * @type {object}
 * @property {string} text - Text to display in the header
 * @property {string} class - CSS class
 * @property {string} value - Value to sort
 * @property {number} [width] - Width of the column
 * @property {boolean} [sortable] - Enable sorting
 * @property {boolean} [sticky] - Enable
 */

/** @type {HeadersTable[]} */
export const HEADERS_TABLE = [
  {
    text: "Actions",
    class: "font-size-table-header",
    value: "actions",
    width: 25,
    sortable: false,
    sticky: true
  },
  {
    text: "Duplicado",
    class: "py-4 font-size-table-header",
    value: "contact_lead.duplicated",
    sortable: false
  },
  {
    text: "Coincidencias",
    class: "py-4 font-size-table-header",
    value: "contact_match",
    sortable: false
  },
  {
    text: "Nombre",
    class: "font-size-table-header ",
    value: "contact_lead.name",
    width: 170,
    sticky: true
  },
  {
    text: "Teléfono",
    class: "font-size-table-header ",
    value: "contact_lead.phone"
  },
  {
    text: "Correo",
    class: "font-size-table-header ",
    value: "contact_lead.email"
  },
  {
    text: "Llegó por",
    class: "font-size-table-header ",
    value: "zones"
  },
  {
    text: "Presupuesto",
    class: "font-size-table-header ",
    value: "budget"
  },
  {
    text: "¿Cómo nos encontró?",
    class: "font-size-table-header ",
    value: "contact",
    width: 170,
    sortable: false
  },
  {
    text: "Asignado a",
    class: "font-size-table-header ",
    value: "internal_broker",
    sortable: false
  },
  {
    text: "Status",
    class: "font-size-table-header ",
    value: "tracking_phase"
  },
  {
    text: "Siguiente acción",
    class: "py-4 font-size-table-header",
    value: "postponed.date_at"
  },
  {
    text: "Tags",
    class: "py-4 font-size-table-header ",
    value: "multi_sales_opportunities",
    width: 180
  },
  {
    text: "Idioma",
    class: "py-4 font-size-table-header",
    value: "contact.language"
  },
  {
    text: "Perfilación",
    class: "py-4 font-size-table-header",
    value: "category"
  },
  {
    text: "Intentos de contacto",
    class: "py-4 font-size-table-header",
    value: "contact_attempts",
    sortable: false
  }
];
